import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: ReactNode;
  variant?: 'primary' | 'outline';
  className?: string;
  onClick?: () => void;
}
export function Button({
  children,
  variant = 'primary',
  className = '',
  onClick
}: ButtonProps) {
  const baseStyles = 'relative inline-flex items-center justify-center px-8 py-4 font-display text-xl tracking-wide uppercase transition-all duration-300 overflow-hidden rounded-sm';
  const variants = {
    primary: 'bg-gradient-gold text-black hover:shadow-[0_0_30px_rgba(212,175,55,0.4)] hover:scale-[1.02]',
    outline: 'border-2 border-gold-500 text-gold-400 hover:bg-gold-500/10'
  };
  return <motion.button whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${className}`} onClick={onClick} data-id="element-304">
      {variant === 'primary' && <div className="absolute inset-0 bg-white/20 translate-y-[-100%] group-hover:translate-y-[100%] transition-transform duration-500 ease-in-out" data-id="element-305" />}
      <span className="relative z-10 flex items-center gap-2" data-id="element-306">{children}</span>
    </motion.button>;
}